import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=3af99c81&scoped=true&"
import script from "./Newsletter.vue?vue&type=script&lang=js&"
export * from "./Newsletter.vue?vue&type=script&lang=js&"
import style0 from "./Newsletter.vue?vue&type=style&index=0&id=3af99c81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af99c81",
  null
  
)

export default component.exports